// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"e3f2c450","774":"8fb4e646","787":"e85ba5b5"}[chunkId] + ".chunk.js";
};